import { defineStore } from 'pinia';

const STORAGE_THEME = 'kosexa-appearance';
const STORAGE_PROMPTED = 'kosexa-appearance-prompted';

export const useAppearanceStore = defineStore('appearance', {
  state: () => ({
    /** @type {'dark' | 'light'} */
    theme: 'dark',
    showWelcomeThemeModal: false,
    hydrated: false,
  }),
  actions: {
    hydrateFromStorage() {
      if (typeof window === 'undefined' || !window.localStorage) return;
      try {
        const t = window.localStorage.getItem(STORAGE_THEME);
        this.theme = t === 'light' ? 'light' : 'dark';
      } catch {
        this.theme = 'dark';
      }
      this.applyDom();
      this.hydrated = true;
    },
    /** Tras montar la app: primera visita sin bandera → modal de bienvenida. */
    initWelcomeModal() {
      if (typeof window === 'undefined' || !window.localStorage) return;
      try {
        const asked = window.localStorage.getItem(STORAGE_PROMPTED) === '1';
        this.showWelcomeThemeModal = !asked;
      } catch {
        this.showWelcomeThemeModal = true;
      }
    },
    setTheme(theme) {
      this.theme = theme === 'light' ? 'light' : 'dark';
      if (typeof window !== 'undefined' && window.localStorage) {
        try {
          window.localStorage.setItem(STORAGE_THEME, this.theme);
        } catch {
          /* ignore */
        }
      }
      this.applyDom();
      if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function') {
        window.dispatchEvent(
          new CustomEvent('kosexa-appearance-changed', { detail: { theme: this.theme } }),
        );
      }
    },
    completeWelcomeChoice(theme) {
      if (typeof window !== 'undefined' && window.localStorage) {
        try {
          window.localStorage.setItem(STORAGE_PROMPTED, '1');
        } catch {
          /* ignore */
        }
      }
      this.setTheme(theme);
      this.showWelcomeThemeModal = false;
    },
    toggleTheme() {
      this.setTheme(this.theme === 'dark' ? 'light' : 'dark');
    },
    applyDom() {
      if (typeof document === 'undefined') return;
      if (this.theme === 'light') {
        document.documentElement.setAttribute('data-theme', 'light');
      } else {
        document.documentElement.removeAttribute('data-theme');
      }
      const meta = document.querySelector('meta[name="theme-color"]');
      if (meta) {
        meta.setAttribute('content', this.theme === 'light' ? '#f4f1ea' : '#070a08');
      }
    },
  },
});
